import {
  EMPLOYEE_ONBOARDING_PATH,
  PROJECT_PATH,
  EMPLOYEE_OFFBOARDING_PATH,
} from '../url';
import { useParams } from 'react-router-dom';
import ErrorSwitchCase from './ErrorHandlerService';
import HttpService from './HttpService';
import { useEffect } from 'react';
import KeycloakService from './KeycloakService';
const _axios = HttpService.getAxiosClient();

export const addOrUpdateEmployeeOnboardingRequest = async (
  employee,
  uploadedPhoto,
) => {
  try {
    const formData = new FormData();
    formData.append('applierId', employee.applierId);
    if (employee.id) formData.append('id', employee.id);
    // formData.append("employeeCode", employee.employeeCode);
    formData.append('firstName', employee.firstName);
    if (employee.createdBy) formData.append('createdBy', employee.createdBy);
    if (employee.createdAt) formData.append('createdAt', employee.createdAt);
    formData.append('lastName', employee.lastName);
    formData.append('designation', employee.designation);
    formData.append('locationId', employee.locationId);
    formData.append('locationName', employee.locationName);
    formData.append('gender', employee.gender);
    formData.append('dateOfBirth', employee.dateOfBirth);
    if (employee.photo) formData.append('photo', employee.photo);
    formData.append('status', employee.status);
    formData.append('usageLocation', employee.usageLocation);
    formData.append('phoneNumber', employee.phoneNumber);
    formData.append('personalEmailId', employee.personalEmailId);
    if (employee.dateOfJoining) {
      formData.append(
        'dateOfJoining',
        new Date(employee.dateOfJoining).toUTCString(),
      );
    }
    if (employee.dateOfInternship) {
      formData.append(
        'dateOfInternship',
        new Date(employee.dateOfInternship).toUTCString(),
      );
    }
    if (employee.careerStartDate) {
      formData.append(
        'careerStartDate',
        new Date(employee.careerStartDate).toUTCString(),
      );
    }
    if (employee.internshipEndDate) {
      formData.append(
        'internshipEndDate',
        new Date(employee.internshipEndDate).toUTCString(),
      );
    }
    if (employee.organizationEmailId != null) {
      formData.append('organizationEmailId', employee.organizationEmailId);
    }
    formData.append('jobType', employee.jobType);
    if (employee.leaveGroupId != null && employee.leaveGroupId !== '') {
      formData.append('leaveGroupId', employee.leaveGroupId);
    }
    if (
      employee.reportingManagerId != null &&
      employee.reportingManagerId !== ''
    ) {
      formData.append('reportingManagerId', employee.reportingManagerId);
    }

    formData.append('file', uploadedPhoto);

    const response = await _axios.post(
      `${EMPLOYEE_ONBOARDING_PATH}`,
      formData,
      {
        headers: {
          'Content-Type': 'multipart/form-data',
        },
      },
    );
    console.log(response, 'response');
    return ErrorSwitchCase(response);
  } catch (error) {
    return ErrorSwitchCase(error?.response?.data);
  }
};

export const checkForJobType = async (jobType) => {
  try {
    const response = await _axios.get(
      `${EMPLOYEE_ONBOARDING_PATH}/next-employee-id?jobType=${jobType}`,
    );
    return ErrorSwitchCase(response);
  } catch (error) {
    return ErrorSwitchCase(error.response.data);
  }
};

export const checkForEmailId = async (email) => {
  try {
    const response = await _axios.get(
      `${EMPLOYEE_ONBOARDING_PATH}/check-email-availability?email=${email}`,
    );
    return ErrorSwitchCase(response);
  } catch (error) {
    return ErrorSwitchCase(error.response.data);
  }
};

export const getAllEmployees = async (
  pageSize,
  pageNo,
  eName,
  status,
  orgEmail,
  searchString,
) => {
  try {
    const response = await _axios.get(
      `${EMPLOYEE_ONBOARDING_PATH}/all?${
        pageSize ? 'pageSize=' + pageSize : ''
      }${pageNo >= 0 ? '&pageNumber=' + pageNo : ''}${
        eName ? '&firstName=' + eName : ''
      }${status ? '&status=' + status : ''}${
        orgEmail ? '&orgEmail=' + orgEmail : ''
      }${searchString ? '&searchString=' + searchString : ''}`,
    );
    // `${EMPLOYEE_ONBOARDING_PATH}/all/${tenantId}?${searchString?"&searchString="+searchString:""}`);

    return ErrorSwitchCase(response);
  } catch (error) {
    return ErrorSwitchCase(error.response?.data);
  }
};

export const getAllEmployeesByName = async (tenantId, searchString) => {
  try {
    const response = await _axios.get(
      `${EMPLOYEE_ONBOARDING_PATH}/all?${
        searchString ? '&searchString=' + searchString : ''
      }`,
    );

    // `${EMPLOYEE_ONBOARDING_PATH}?${eName?"name="+eName:""}`);

    return ErrorSwitchCase(response);
  } catch (error) {
    return ErrorSwitchCase(error.response?.data);
  }
};

export const checkForEmployeeId = async (employeeCode, tenantId) => {
  try {
    const response = await _axios.get(
      `${EMPLOYEE_ONBOARDING_PATH}/check-employeeCode-availability?employeeCode=${employeeCode}`,
    );
    return ErrorSwitchCase(response);
  } catch (error) {
    return ErrorSwitchCase(error.response?.data);
  }
};

export const nextAvailableEmployeeCode = async (jobType) => {
  try {
    const response = await _axios.get(
      `${EMPLOYEE_ONBOARDING_PATH}/next-employee-id?jobType=${jobType}`,
    );
    return ErrorSwitchCase(response);
  } catch (error) {
    return ErrorSwitchCase(error.response?.data);
  }
};

export const updateEmployee = async (updatedEmployeeDetails) => {
  try {
    const response = await _axios.put(
      `${PROJECT_PATH}/users`,
      updatedEmployeeDetails,
    );
    return ErrorSwitchCase(response);
  } catch (error) {
    return ErrorSwitchCase(error.response?.data);
  }
};

export const updateEmployeeOnBoardingRequest = async (employeeDetails) => {
  try {
    const formData = new FormData();
    formData.append('applierId', employeeDetails.applierId);
    if (employeeDetails.createdBy)
      formData.append('createdBy', employeeDetails.createdBy);
    if (employeeDetails.createdAt)
      formData.append('createdAt', employeeDetails.createdAt);
    formData.append('id', employeeDetails.id);
    formData.append('approverId', employeeDetails.approverId);
    formData.append('gender', employeeDetails.gender);
    formData.append('firstName', employeeDetails.firstName);
    formData.append('lastName', employeeDetails.lastName);
    formData.append('designation', employeeDetails.designation);
    formData.append('locationId', employeeDetails.locationId);
    formData.append('locationaName', employeeDetails.locationName);
    formData.append('dateOfBirth', employeeDetails.dateOfBirth);
    formData.append('status', employeeDetails.status);
    formData.append('usageLocation', employeeDetails.usageLocation);
    formData.append('phoneNumber', employeeDetails.phoneNumber);
    formData.append('personalEmailId', employeeDetails.personalEmailId);
    if (employeeDetails.dateOfJoining) {
      formData.append(
        'dateOfJoining',
        new Date(employeeDetails.dateOfJoining).toUTCString(),
      );
    }

    if (employeeDetails.dateOfInternship) {
      formData.append(
        'dateOfInternship',
        new Date(employeeDetails.dateOfInternship).toUTCString(),
      );
    }
    if (employeeDetails.careerStartDate) {
      formData.append(
        'careerStartDate',
        new Date(employeeDetails.careerStartDate).toUTCString(),
      );
    }
    if (employeeDetails.internshipEndDate) {
      formData.append(
        'internshipEndDate',
        new Date(employeeDetails.internshipEndDate).toUTCString(),
      );
    }
    if (employeeDetails.organizationEmailId != null) {
      formData.append(
        'organizationEmailId',
        employeeDetails.organizationEmailId,
      );
    }
    if (employeeDetails.employeeCode != null) {
      formData.append('employeeCode', employeeDetails.employeeCode);
    }
    formData.append('photo', employeeDetails.photo);
    formData.append('jobType', employeeDetails.jobType);
    if (
      employeeDetails.leaveGroupId != null &&
      employeeDetails.leaveGroupId !== ''
    ) {
      formData.append('leaveGroupId', employeeDetails.leaveGroupId);
    }
    if (
      employeeDetails.reportingManagerId != null &&
      employeeDetails.reportingManagerId !== ''
    ) {
      formData.append('reportingManagerId', employeeDetails.reportingManagerId);
    }

    const response = await _axios.put(
      `${EMPLOYEE_ONBOARDING_PATH}/update`,
      formData,
      {
        headers: {
          'Content-Type': 'multipart/form-data',
        },
      },
    );

    return ErrorSwitchCase(response);
  } catch (error) {
    return ErrorSwitchCase(error.response?.data);
  }
};

export const addOrUpdateEmployeeByExcel = async (excelFile) => {
  try {
    const formData = new FormData();

    formData.append('file', excelFile);

    const response = await _axios.post(
      `${PROJECT_PATH}/users/excel`,
      formData,
      {
        headers: {
          'Content-Type': 'multipart/form-data',
        },
      },
    );
    console.log(response, 'response');
    return ErrorSwitchCase(response);
  } catch (error) {
    return ErrorSwitchCase(error?.response?.data);
  }
};

export const addOrUpdateEmployeeOffboardingRequest = async (employee, rest) => {
  try {
    const formData = {
      applierId: employee?.applierId ?? KeycloakService.getUserDetail(),
      tenantId: employee.tenantId,
      employeeId: employee.employeeId ?? employee.id,
      organizationEmailId: employee.organizationEmailId ?? employee.emailId,
      approverId: rest.approverId,
      endDate: rest.endDate,
      expectedEndDate: rest.expectedEndDate,
      comments: rest.comments,
      status: rest.status,
    };
    const response = await _axios.post(
      `${EMPLOYEE_OFFBOARDING_PATH}`,
      formData,
      {},
    );
    return ErrorSwitchCase(response);
  } catch (error) {
    return ErrorSwitchCase(error?.response?.data);
  }
};

export const updateEmployeeOffBoardingRequest = async (employee, rest = {}) => {
  try {
    const formData = {
      id: employee?.id,
      applierId: employee?.applierId,
      tenantId: employee.tenantId,
      employeeId: employee.employeeId ?? employee.id,
      organizationEmailId: employee.organizationEmailId ?? employee.emailId,
      approverId: rest.approverId ?? employee.approverId,
      endDate: rest.endDate ?? employee.endDate,
      expectedEndDate: rest.expectedEndDate ?? employee.expectedEndDate,
      comments: rest.comments ?? employee.comments,
      status: rest.status ?? employee.status,
    };

    const response = await _axios.put(
      `${EMPLOYEE_OFFBOARDING_PATH}/update`,
      formData,
    );

    return ErrorSwitchCase(response);
  } catch (error) {
    return ErrorSwitchCase(error.response?.data);
  }
};

export const getAllEmployeesOffBoarded = async (
  tenantId,
  pageSize,
  pageNo,
  eName,
  status,
  orgEmail,
  searchString,
) => {
  try {
    const response = await _axios.get(
      `${EMPLOYEE_OFFBOARDING_PATH}/all/${tenantId}?${
        pageSize ? 'pageSize=' + pageSize : ''
      }${pageNo >= 0 ? '&pageNumber=' + pageNo : ''}${
        eName ? '&firstName=' + eName : ''
      }${status ? '&status=' + status : ''}${
        orgEmail ? '&organizationEmailId=' + orgEmail : ''
      }${searchString ? '&searchString=' + searchString : ''}`,
    );
    return ErrorSwitchCase(response);
  } catch (error) {
    return ErrorSwitchCase(error.response?.data);
  }
};
